module.exports = __webpack_public_path__ + "static/media/cl.65517b63.svg";